module.exports = __webpack_public_path__ + "static/media/edugroovedefault.68db0bfa.webp";